import * as React from 'react';
import {
    Route, Switch, Redirect,
} from 'react-router-dom';

import Home from './Home';
import EditStudent from './EditStudent';
import Skills from './Skills';
import Plan from './Plan';
import Today from './Today';
import Task from './Task';

import LoadStudent from './components/LoadStudent';

import urls from '../../app/urls';
import { PageNotFound } from '../../youwell-common/components';
import Progress from './Progress';

const RedirectToHome = ({ ...rest }) => (
    <Route
        {...rest}
        render={() => (
            <Redirect to={{
                pathname: urls.inside.home,
            }}
            />
        )}
    />
);

class Index extends React.Component {
    render() {
        return (
            <>
                <Switch>
                    <Route exact path={urls.inside.student.home} component={RedirectToHome} />
                    <Route exact path={urls.inside.student.new} component={EditStudent} />
                    <Route path={`${urls.inside.student.home}/:studentId`} component={LoadStudent} />
                </Switch>

                <Switch>
                    <Route exact path={`${urls.inside.student.home}/:studentId`} component={Home} />
                    <Route exact path={`${urls.inside.student.home}/:studentId/${urls.inside.student.parts.progress}`} component={Progress} />
                    <Route exact path={`${urls.inside.student.home}/:studentId/${urls.inside.student.parts.skills}`} component={Skills} />
                    <Route path={`${urls.inside.student.home}/:studentId/${urls.inside.student.parts.plan}/:skillNr?`} component={Plan} />
                    <Route exact path={`${urls.inside.student.home}/:studentId/${urls.inside.student.parts.today}`} component={Today} />
                    <Route exact path={`${urls.inside.student.home}/:studentId/${urls.inside.student.parts.task}/:taskId`} component={Task} />
                    <Route exact path={`${urls.inside.student.home}/:studentId/${urls.inside.student.parts.edit}`} component={EditStudent} />
                    <Route component={PageNotFound} />
                </Switch>
            </>
        );
    }
}

export default Index;
